<template>
    <div class="checkout-confirm-button" v-if="activeStep === lastStep">
        <DefButtonPrimary type="submit">
            {{ 'Оформити замовлення' }}
        </DefButtonPrimary>
    </div>
</template>

<script>
import { mapState } from 'vuex';

export default {
    name: "CheckoutConfirmButton",
    data() {
        return {
            lastStep: 4, // измените на актуальный номер последнего шага, если нужно
        };
    },
    computed: {
        ...mapState({
            activeStep: state => state.checkout.data.activeStep,
        }),
    },
};
</script>

<style lang="scss" scoped>
.checkout-confirm-button {
    text-align: center;

    :deep(.def-button-primary) {
        width: 100%;
        margin-bottom: 16px;

        @include point-md {
            width: auto;
            align-self: flex-end;
            min-width: 320px;
        }

        @include point-lg {
            width: 100%;
            min-width: auto;
        }
    }
}
</style>
